import React, { ReactElement } from 'react'
import Footer from '../Footer/Footer'
import './Layout.scss'
import './Animations.scss'
import SEO from '../SEO/SEO'
import PropertyHeader from '../Header/PropertyHeader'
import toCamelCase from '../../content/toCamelCase'

type LayoutPropTypes = {
  children?: string | Element | ReactElement | boolean | (string | Element | ReactElement | boolean)[]
}

const PropertyLayout = (props: any) => {
  const data = props.pageData
  const propertyData = data.pageContext.property.details
  const { seoTitle, seoDescription } = data.pageContext.property[toCamelCase(data.pathContext.type)]
  const defaultTitle = `${propertyData.name} - ${propertyData.brand.toUpperCase()} | AyalaLand International Sales Inc.`
  return (
    <>
      <SEO {...{ seoTitle, seoDescription, defaultTitle }} />
      <PropertyHeader {...props} />
      {props.children}
      <Footer />
    </>
  )
}

export default PropertyLayout
